"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VERSION_WIDTHS = [1920, 1280, 1080, 800, 500, 400, 300, 200, 100];
var MediaType;
(function (MediaType) {
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var MediaState;
(function (MediaState) {
    MediaState["EXTERNAL"] = "EXTERNAL";
    MediaState["PROCESSING"] = "PROCESSING";
    MediaState["READY"] = "READY";
    MediaState["ERROR"] = "ERROR";
    MediaState["UPLOAD"] = "UPLOAD";
})(MediaState = exports.MediaState || (exports.MediaState = {}));
var MediaOriginType;
(function (MediaOriginType) {
    MediaOriginType["TEMPLATE"] = "TEMPLATE";
    MediaOriginType["EXPORT_SET"] = "EXPORT_SET";
    MediaOriginType["DRIVE"] = "DRIVE";
    MediaOriginType["COLLECTION"] = "COLLECTION";
    MediaOriginType["EXTERNAL_STOCK"] = "EXTERNAL_STOCK";
    MediaOriginType["UPLOAD"] = "UPLOAD";
    MediaOriginType["DATA_APP"] = "DATA_APP";
})(MediaOriginType = exports.MediaOriginType || (exports.MediaOriginType = {}));
//# sourceMappingURL=Media.js.map